module.exports = __webpack_public_path__ + "img/mypage_banner_01.ad48101b.png";